module.exports = __webpack_public_path__ + "static/media/q1.9a96eb13.jpg";